import styled, { css } from 'styled-components'

export const StyledLoaderContainer = styled.i``

export const StyledDrawerTitle = styled.h1`
  ${({ theme }) => css(theme.variants.paragraph1.regular)};
  color: ${({ theme }) => theme.color.darkGrey800};
  line-height: 2rem;
  text-align: center;
`

export const StyledTitleContainer = styled.div`
  position: relative;

  ${StyledLoaderContainer} {
    position: absolute;
  }
`

export const StyledTabContainer = styled.div`
  flex-grow: 1;
  padding-bottom: ${({ theme }) => `calc(${theme.spacings.xxxLarge} + ${theme.spacings.medium})`};

  .ant-tabs-nav-list {
    justify-content: center;
    width: 100%;
  }

  .ant-tabs-tab {
    padding: ${({ theme }) => theme.spacings.small} 0;
  }
`

export const StyledFooter = styled.div`
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.05);
  bottom: 0;
  display: flex;
  padding: ${({ theme }) => theme.spacings.xSmall};
  position: sticky;

  button {
    flex: 1 50%;
  }

  button + button {
    margin-left: ${({ theme }) => theme.spacings.xSmall};
  }
`
